import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  GeoJsonFeatureCollection,
  GetBulkIsochronePayload
} from "@/types/isochorne";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getBulkIsochrone = async (
  payload: GetBulkIsochronePayload
): Promise<GeoJsonFeatureCollection[]> => {
  try {
    const { data } = await axiosInstance.post("/v1/isochrone", payload);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
